import React, { useEffect, useState } from 'react';
import NavContainer from '../components/Navigation/NavContainer';
import { useAppDispatch, useAppSelector } from '../hooks';
import { getSCTeamsPage, selectSCTeamsFrontPage, selectLoading } from '../state/reducers/SCTeamsReducer';
import { PlacingTableColumns, RenderHomePlacingTableColumns, TopNPlacingsTableColumns, RenderTopNPlacingTableColumns } from '../globals/TableFunctions';
import { GridColDef, GridCellParams, GridRowParams, GridEvents, MuiEvent, GridCallbackDetails, GridRenderCellParams } from '@mui/x-data-grid';
import { Paper, Tooltip } from '@mui/material';
import PlayerDataGrid from '../components/DataGrid/PlayerDataGrid';
import PlacingsTable from '../components/Tables/PlacingsTable';
import PlacingsTable2 from '../components/Tables/PlacingsTable2';
import CarouselContainer from '../components/Carousel/CarouselContainer';
import CaptainsCard from '../components/Cards/CaptainsCard';
import FeaturedTeamContainer from '../components/FrontPage/FeaturedTeamContainer';
import { ContentWrapper, PageContainer } from '../globals/styles';
import Header from '../components/Header/Header';
import { useNavigate } from 'react-router-dom';
import Loading from '../components/Loading';
import PlayerCardSimpleStats from '../components/Cards/PlayerCardSimpleStats';
import { RegisterPageView } from '../globals/Analytics';
import MyTransition from '../components/Theming/MyTransition';

const SCTeams = () => {
    const router = useNavigate();
    const dispatch = useAppDispatch();
    const [ animate, setAnimate ] = useState(false);
    const [ done, setDone] = useState(false);
    RegisterPageView({path:'/scteams'});

    useEffect(() => {
        dispatch(getSCTeamsPage())
    },[]);

    const isloading = useAppSelector(selectLoading);
    const scTeamsFrontPage = useAppSelector(selectSCTeamsFrontPage);
    
    useEffect(() => {

    },[isloading]);

    setTimeout(() => {
        if (!isloading === 'loading') {
            setAnimate(true);
        }
    },500)
    
    let placings = scTeamsFrontPage['placings'];
    let diffs = scTeamsFrontPage['diffs'];
    let diffstop1000 = scTeamsFrontPage['diffstop1000'];
    let mostCaptained = scTeamsFrontPage['mostcaptained'];
    
    let lastRoundBestTeam = scTeamsFrontPage['lastRoundBestTeam'];
    let lastRoundBestPlacing = scTeamsFrontPage['lastRoundsBestPlacing'];
    let featuredTeam = scTeamsFrontPage['featured_team']
    let featuredTrades = scTeamsFrontPage['trades'];
    const PlacingTableRows = RenderHomePlacingTableColumns(placings);
    const diffsTop1000Rows = RenderTopNPlacingTableColumns(diffstop1000);
    const onCellClick = (params: GridCellParams, event: MuiEvent<React.MouseEvent>, details: GridCallbackDetails) => { 
        router(`/scteam/${params.row.teamid}`);
    };

    
    
    return <PageContainer style={{rowGap: "1rem", display: "flex", flexDirection: "column"}}>
        <Loading isLoading={isloading==='loading'} setDone={setDone} />
        <Header />
        <MyTransition location="/scteams" inProp={animate}>
            <div style={{display: "flex", rowGap: "1rem", flexDirection: "column"}}>
                <FeaturedTeamContainer featuredTeam={featuredTeam} playerOwnerships={lastRoundBestTeam} placing={lastRoundBestPlacing} />
                <PlacingsTable2 placings={placings} tooltipText="Top SC Teams - overall ranking"/>
                
                <Paper elevation={5} style={{paddingTop: "0.5rem"}}>
                    <Tooltip title={"SC Teams in the top 1k that have had the biggest change in ranking over the last round"}>
                        <h4 style={{marginLeft: "0.5rem"}}>Biggest Changes in Top 1k Teams</h4>
                    </Tooltip>
                    <PlayerDataGrid
                        height={800}
                        rows={diffsTop1000Rows}
                        columns={TopNPlacingsTableColumns}
                        onCellClick={onCellClick}
                        rowHeight={84}
                    />
                </Paper>
                <CarouselContainer title={"Most Captained"} description={"Players who have been made the captain of the most teams"} icon={"Captain"}>
                    {mostCaptained?.map(function(mostCaptained) {
                        return <CaptainsCard mostCaptained={mostCaptained} />
                    })}
                </CarouselContainer> 
                <div style={{display: "flex", flexDirection: "row", columnGap: "0.25rem",maxWidth: "100%", width: "100%"}}>
                    <div style={{width: '50%'}}>
                        <CarouselContainer title={"Most Traded IN"} description={"Players who have been traded in"} icon={"In"}>
                            {featuredTrades?.in?.map(function(inTrade) {
                                return <PlayerCardSimpleStats 
                                    player={inTrade.player}
                                    width="200px"
                                    onPlusClick={e => console.log("")}
                                    onNavClick={e => console.log("")}
                                    headerElement={<div>
                                        <p>Trades: {inTrade.amount}</p>
                                    </div>}
                                />
                            })}
                        </CarouselContainer> 
                    </div>
                    <div style={{width: '50%'}}>
                        <CarouselContainer title={"Most Traded OUT"} description={"Players who have been traded out"} icon={"Out"}>
                            {featuredTrades?.out?.map(function(inTrade) {
                                return <PlayerCardSimpleStats 
                                    player={inTrade.player}
                                    width="200px"
                                    onPlusClick={e => console.log("")}
                                    onNavClick={e => console.log("")}
                                    headerElement={<div>
                                        <p>Trades: {inTrade.amount}</p>
                                    </div>}
                                />
                            })}
                        </CarouselContainer> 
                    </div>
                </div>
            </div>
        </MyTransition>
    </PageContainer>

}

export default SCTeams;